import 'dayjs/locale/zh-tw';

import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localeData from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';

import langHandler from '../i18n/langHandler';

dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);
dayjs.extend(localeData);

export function formatTime(unixTime, format = 'YYYY-MM-DD HH:mm') {
  const theTime = new Date(unixTime * 1000);
  const userLocale =
    langHandler.get() === 'zh' ? 'zh-tw' : langHandler.get().toLowerCase();

  return dayjs(theTime).locale(userLocale).format(format);
}

export function formatToLiteralTime(unixTime: number): string {
  const theTime = unixTime * 1000;
  const threshold = dayjs().subtract(3, 'week');
  const userLocale = langHandler.get() === 'zh' ? 'zh-tw' : langHandler.get();

  return dayjs(theTime).isSameOrBefore(threshold)
    ? formatTime(theTime / 1000)
    : dayjs(theTime).locale(userLocale).fromNow();
}
